export const CATEGORY_STATUS = {
  active: { label: 'فعال', value: 'active' },
  deactive: { label: 'غیر فعال', value: 'deactive' },
};
